// The fowling const is helping us to find the color of each icon

export const iconColors = {
  "react.js": "#5ad2ea",
  csharp: "#9a4993",
  ".net": "#10659e",
  prisma: "#53956a",
  angular: "#dd0031",
  tailwind: "#2abbf8",
  docker: "#099cec",
  "next.js": "#000000",
  "sqlserver": "#a91c22",
  redux: "#764abc",
  apollographgl: "#311c87",
  javascript: "#f7df1e",
  javascriptes6: "#f7df1e",
  typescript: "#3178c6",
  html5: "#e34f26",
  css3: "#1572b6",
  sass: "#cc6699",
  "styled-components": "#db7093",
  chakraui: "#319795",
  jest: "#c21325",
  testinglibrary: "#e33332",
  "node.js": "#339933",
  git: "#f05032",
  github: "#181717",
  gitlab: "#fc6d26",
  vercel: "#000000",
  firebase: "#ffca28",
  java: "#007396",
  "express.js": "#000000",
  springboot: "#6db33f",
  nestjs: "#e0234e",
  SiPuppeteer: "",
  puppeteer: "#40b5a4",
  webpack: "#8dd6f9",
  babel: "#f9dc3e",
  prettier: "#f7b93e",
  eslint: "#4b32c3",
  jquery: "#0769ad",
  drupal: "#0678be",
  bootstrap: "#7952b3",
  microsoftazure: "#0078d4",
  docker: "#2496ed",
  jasmine: "#8a4182",
  cucumber: "#23d96c",
  swagger: "#85ea2d",
  vscode: "#007acc",
  kibana: "#005571",
  nodered: "#8f0000",
  shopify: "#7ab55c",
  framer: "#0055ff",
  npm: "#cb3837",
  yarn: "#2c8ebb",
  storybook: "#ff4785",
  "rxjs/ngrx": "#b7178c",
  bitbucket: "#0052cc",
  jira: "#0052cc",
  confluence: "#172b4d",
  weblate: "#2eccaa",
  material: "#757575",
};
